import { createQueryClient } from "@repo/query";

/**
 * webview 全局 QueryClient。
 * token 由根路由 beforeLoad 先写入 sessionStorage 再渲染组件树，所以这里不需要等待鉴权就绪；
 * 登出 / 登录失效时由 AuthProvider 直接 `clear()` 整个缓存。
 */
export const queryClient = createQueryClient();
